import { FC } from 'react';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import { Testimonial } from '@modules/Tributes/Views/CreateTribute/Testimonial';
import { DetailsStep } from '@modules/Tributes/Views/Wizard/DetailsStep';
import { PackageOverview } from '@modules/Tributes/Views/CreateTribute/PackageOverview';


type Props = {
  onComplete: () => void,
}

export const DetailsStepWrapper: FC<Props> = ({ onComplete }) => {
  return (
    <Grid container size={12} spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Stack gap={2} direction={{ xs: 'column-reverse', sm: 'column' }}>
          <Testimonial />
          <DetailsStep onComplete={onComplete} />
        </Stack>
      </Grid>
      <Grid display={{ xs: 'none', sm: 'block' }} size={{ xs: 12, md: 6 }}>
        <PackageOverview />
      </Grid>
    </Grid>
  );
};
